<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="-0.4 -0.5 17 17"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M9.153 13.333c.514 0 .835.557.577 1.002-.358.616-1.017.996-1.73.996-.713 0-1.372-.38-1.73-.996-.258-.445.063-1.002.577-1.002h2.306zM8 .667c1.016 0 1.965.284 2.773.776-.558.14-1.064.407-1.487.768C8.883 2.074 8.45 2 8 2 5.79 2 4 3.79 4 6v3.333c0 .486-.13.941-.357 1.334h8.714C12.13 10.274 12 9.819 12 9.333v-.681c.477-.043.927-.177 1.333-.385v1.066c0 .737.597 1.334 1.334 1.334.889 0 .889 1.333 0 1.333H1.333c-.889 0-.889-1.333 0-1.333.737 0 1.334-.597 1.334-1.334V6C2.667 3.054 5.054.667 8 .667zM11.079 2l.054.083c.124.188.283.312.455.354.053.013.096.02.137.02.028-.001.053-.005.114-.018.178-.037.342-.156.469-.34l.056-.082.097.026c.263.07.516.175.755.314l.086.05-.018.098c-.041.223-.009.425.092.575.023.036.045.063.068.086.027.027.058.051.096.076.153.098.356.127.58.082l.098-.02.051.085c.145.235.256.483.33.738l.03.102-.089.057c-.167.108-.285.246-.343.397-.03.078-.045.144-.045.208 0 .078.02.158.061.247.067.147.193.278.365.379l.089.052-.023.101c-.058.26-.147.508-.267.739l-.053.103-.112-.032c-.169-.049-.332-.056-.475-.024-.12.028-.223.082-.302.162-.09.09-.149.21-.171.35-.024.149-.008.315.049.484l.036.107-.096.059c-.221.136-.454.242-.693.317l-.118.036-.052-.111c-.072-.151-.168-.276-.283-.369-.125-.101-.259-.154-.394-.153-.146 0-.29.06-.42.173-.109.094-.202.223-.272.38l-.05.109-.116-.031c-.243-.066-.479-.162-.7-.287l-.107-.06.043-.114c.06-.158.087-.314.078-.457-.01-.173-.07-.318-.176-.424-.1-.101-.238-.16-.402-.174-.143-.013-.3.011-.458.07l-.117.043-.058-.11c-.116-.221-.204-.46-.265-.711l-.026-.111.102-.05c.156-.076.284-.18.377-.305.091-.122.139-.248.14-.376 0-.114-.038-.228-.11-.339-.081-.122-.202-.228-.355-.31l-.104-.056.035-.112c.079-.248.19-.485.329-.707l.056-.09.102.029c.185.05.363.052.513.006.099-.03.183-.08.25-.148.058-.058.102-.127.133-.207.057-.145.065-.32.022-.508l-.024-.105.095-.051c.235-.126.488-.22.755-.283L11.079 2zm.588 2c-.553 0-1 .448-1 1s.447 1 1 1c.552 0 1-.448 1-1s-.448-1-1-1z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-bell",
  components: {},
})
export class IconBell extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconBell;
</script>
